import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Defi() {
    return (
        <Container>
            <Row> 
                <Col lg={12} >
                    <div className='lending-heading'>Lending</div>
                </Col>
                <Col lg={12} className='active-border'> 
                    <Col lg={12}>
                        <div  className='active-loans'>Active Loans</div>
                    </Col>
                    <Col lg={12} md={12}>
                        <Row>
                            <Col lg={12} md={12}>
                                <div className='active-container'>
                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Payoff</Link>
                                    </div>
                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Payoff</Link>
                                    </div>
                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Payoff</Link>
                                    </div>

                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Payoff</Link>
                                    </div>

                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Payoff</Link>
                                    </div>
                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Payoff</Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={12}>
                        <div  className='active-loans'>Active Lendings</div>
                    </Col>
                    <Col lg={12} md={12}>
                        <Row>
                            <Col lg={12} md={12}>
                                <div className='active-container-2nd'>
                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Cancel Loan</Link>
                                    </div>
                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Cancel Loan</Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Col>
            </Row>


            <Row>
            <Col lg={12} >
                    <div className='lending-heading'>Leasing</div>
                </Col>
                <Col lg={12} className='active-border'> 
                    <Col lg={12}>
                        <div  className='active-loans'>Active Renting</div>
                    </Col>
                    <Col lg={12} md={12}>
                        <Row>
                            <Col lg={12} md={12}>
                                <div className='active-container'>
                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Payoff</Link>
                                    </div>
                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Payoff</Link>
                                    </div>
                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Payoff</Link>
                                    </div>

                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Payoff</Link>
                                    </div>

                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Payoff</Link>
                                    </div>
                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        <Link to='#'>Payoff</Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={12}>
                        <div  className='active-loans'>Active Leasing</div>
                    </Col>
                    <Col lg={12} md={12}>
                        <Row>
                            <Col lg={12} md={12}>
                                <div className='active-container-2nd'>
                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        {/* <Link to='#'>Cancel Loan</Link> */}
                                    </div>
                                    <div className='active-item'>
                                        <span><img src="" alt="Loan" /></span>
                                        <span>Loan Name XYZ</span>
                                        <span>Total 1M - 100</span>
                                        {/* <Link to='#'>Cancel Loan</Link> */}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Col>
            </Row>
        </Container>
    )
}

export default Defi;
